import BaseEntity from '../base/BaseEntity.model';

export default class Transaccion extends BaseEntity {
    public tarjetaId?: number;
    public subsidioId?: number;
    public comercioId?: number;
    public monto?: string;
    public noAutorizacion?: string;
    public estado?: string;
    public tipo?: string;
    public codigo?: string;
    public noAfiliacion?: string;
    public comercioNombre?: string;
    public fechaTransaccion?: Date;
    public subsidioAbr?: string;
    public subsidioNombre?: string;
    public subsidioCodigo?: string;
    public numeroTarjeta?: string;
    public bancoNombre?: string;
    constructor() {
        super();
        this.init();
    }

    init() {
        this.id = undefined;
        this.monto = undefined;
        this.fechaTransaccion = undefined;
    }
}

